export const highZIndexMap = {
  NAV_BAR: 1000,
  MOBILE_DRAWER: 2000,
  COVID_MODAL: 2001,
};
